var _circle, _path, _path2, _path3, _g, _path4, _path5, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#90dfaa",
    "data-name": "Elipse 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.068 36.982 7.416 33.264l7.308-15.609 6.069 1.1Z",
    "data-name": "Caminho 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e9ee",
    d: "m18.068 36.982 11.252-3.738-2.125-15.59-6.4 1.1Z",
    "data-name": "Caminho 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.766 36.982-13.445-3.738-2.125-15.589 6.728 1.1Z",
    "data-name": "Caminho 3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#84dbff",
    "data-name": "Grupo 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.065 20.399-4.613-.846 1.5 10.986 8.626 2.311Z",
    "data-name": "Caminho 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.728 19.799-5.41 11.842 8.095 2.508 2.065-13.495Z",
    "data-name": "Caminho 5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#54c0eb",
    d: "m27.451 19.553-6.973 1.1-2.066 13.5 10.534-3.61Z",
    "data-name": "Caminho 6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1543f",
    d: "M32.635 13.76c0 4.426-8.016 14.095-8.016 14.095s-8.016-9.669-8.016-14.095a8.016 8.016 0 1 1 16.032 0",
    "data-name": "Caminho 7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.062,
    cy: 4.062,
    r: 4.062,
    fill: "#fff",
    "data-name": "Elipse 2",
    transform: "translate(20.547 9.039)"
  })));
};
export default SvgMap;